<template>
  <div
    v-if="loaded && (items.length > 0 || bannerTitle)"
    class="position-relative"
  >
    <div class="PromotionalCarousel">
      <div>
        <!-- Main Header Section -->
        <section v-if="bannerTitle" class="my-5 px-4 content-container">
          <div
            class="d-flex flex-row justify-content-between align-items-start"
          >
            <h2 class="section-title mb-3">{{ bannerTitle }}</h2>
          </div>
          <div
            class="d-flex flex-row justify-content-between align-items-center"
          >
            <p v-if="bannerDescription" class="header-description mb-0">
              {{ bannerDescription }}
            </p>
            <!--            <div-->
            <!--              v-if="bannerCtaUrl"-->
            <!--              class="btn btn-cta btn-view-more rounded-0 ml-3"-->
            <!--              @click="navigateTo(bannerCtaUrl)"-->
            <!--            >-->
            <!--              {{ bannerCtaText }} <i class="fa-solid fa-chevron-right"></i>-->
            <!--            </div>-->
          </div>
        </section>

        <!-- Content Carousel -->
        <div class="position-relative" v-if="items.length > 0">
          <div class="container">
            <AutomaticCarousel :items="items" :slickOptions="carouselOptions">
              >
              <template #default="{ item, index }">
                <slot name="item" :item="item" :index="index">
                  <PromotionalCard
                    :item="item"
                    :index="index"
                    @card-click="handleCardClick"
                  />
                </slot>
              </template>
            </AutomaticCarousel>
          </div>
          <!-- Fade Blur Container -->
          <div class="d-flex flex-row flex-nowrap blur-container">
            <div class="left-blur"></div>
            <div class="container w-100"></div>
            <div class="right-blur"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import config from "@/config/constants";
import PromotionalCard from "@/components/Home/New/PromotionalCard.vue";
import AutomaticCarousel from "@/components/Carousels/AutomaticCarousel.vue";

export default {
  name: "PromotionalCarousel",
  components: {
    PromotionalCard,
    AutomaticCarousel
  },
  props: {
    carouselOptions: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      loaded: false,
      items: [],
      bannerTitle: null,
      bannerDescription: null,
      bannerCtaText: null,
      bannerCtaUrl: null
    };
  },
  methods: {
    async getPromotionalContent() {
      const url =
        config.api_env + "/application/api/u/marketplace/get-homepage-banner";
      const payload = {
        user_id: this.$store.getters.user_id
      };
      try {
        let res = await axios.post(url, payload, config.options);
        if (res.data.success) {
          const banners = res.data.banners || [];
          const bannerDetails = res.data.promotional_banner_details || {};

          // Map banners to carousel items
          this.items = banners.map(banner => ({
            name: banner.title,
            description: banner.description,
            image_url: banner.image_url,
            button_text: banner.cta_text,
            link: banner.cta_link
          }));

          // Set banner section details
          this.bannerTitle = bannerDetails.title;
          this.bannerDescription = bannerDetails.description;
          this.bannerCtaText = bannerDetails.cta_button_text;
          this.bannerCtaUrl = bannerDetails.cta_url;
        } else if (res.data.err && res.data.err.includes("3994")) {
          this.$store.dispatch("logout");
          this.$router.push("/login");
        }
      } catch (error) {
        // API request failed
      } finally {
        this.loaded = true;
      }
    },
    navigateTo(url) {
      if (url) {
        this.$router.push(url);
        // Reset scroll to the top so the destination page doesn't open at the
        // scroll position of the promo carousel (which sits low on the page).
        this.scrollToRef(null, true);
      }
    },
    handleCardClick(item) {
      if (item.link) {
        this.navigateTo(item.link);
      }
      this.$emit("card-click", item);
    }
  },
  mounted() {
    this.getPromotionalContent();
  }
};
</script>

<style scoped>
.PromotionalCarousel {
  width: 100%;
}

.header-description {
  font-size: 1.8rem !important;
  color: #343c3d !important;
  line-height: 1.6;
  margin-bottom: 2rem;
}

.btn-cta {
  background-color: #00008f;
  border: 1px solid #00008f;
  color: white;
  padding: 0.5rem 1rem;
  transition: all 0.3s ease;
  cursor: pointer;
  white-space: nowrap;
}

.btn-cta:hover {
  background-color: #00006b;
  border-color: #00006b;
}

.btn-view-more {
  font-size: 1.6rem !important;
}

@media (max-width: 768px) {
  .header-description {
    font-size: 1.8rem !important;
  }
}

.horizontal-divider {
  border: none;
  border-top: 1px solid #e0e0e0;
  margin: 0;
}

.blur-container {
  pointer-events: none;
  position: absolute;
  top: 0;
  height: 100%;
  width: 100%;

  .container {
    flex-grow: 1;
  }

  .left-blur {
    flex-grow: 1;
    background: rgb(247, 247, 247);
    background: linear-gradient(
      270deg,
      rgba(250, 250, 250, 0) 5%,
      rgba(250, 250, 250, 0.7) 15%,
      rgba(250, 250, 250, 1) 45%
    );
  }

  .right-blur {
    flex-grow: 1;
    background: rgb(247, 247, 247);
    background: linear-gradient(
      90deg,
      rgba(250, 250, 250, 0) 5%,
      rgba(250, 250, 250, 0.7) 15%,
      rgba(250, 250, 250, 1) 45%
    );
  }
}
</style>
